import Vue from 'vue';
import moment from 'moment';

Vue.filter('dateFormat', (date) => (date ? moment.parseZone(date).format('MM/DD/YYYY') : ''));
Vue.filter('contactDateFormat', (date) => (date ? moment.parseZone(date).format('hh:mma MM/DD/YYYY') : ''));
Vue.filter('arrivedDate', (date) => (date ? moment.parseZone(new Date(date).toISOString()).format('MM/DD/YYYY') : ''));
Vue.filter('arrivedTime', (date) => (date ? moment.parseZone(date).format('hh:mm A ') : ''));
Vue.filter('alertScannedDate', (date) => (date ? moment.parseZone(date).format('MM.DD.YYYY') : ''));
